import { composeWithDevTools } from '@redux-devtools/extension';
import { createStore, applyMiddleware, type ActionFromReducer } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import middleware from './middleware';
import rootReducer from './reducer';

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware())),
);

export type StoreProps = ReturnType<typeof store.getState>;
export type Action = ActionFromReducer<typeof rootReducer>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  StoreProps,
  unknown,
  Action
>;

export default store;
